<div class="chat-details" *ngIf="conversation as conv">
  <div class="chat-details__top">
    <button type="button" class="chat-details__close" [attr.aria-label]="strings.closePanel" (click)="close.emit()">
      <chat-icon name="close" [size]="16"></chat-icon>
    </button>
    <chat-avatar [src]="conv.photo" [name]="conv.name" [size]="80" [status]="presence"></chat-avatar>
    <h2 class="chat-details__name">{{ conv.name }}</h2>
    <p class="chat-details__sub">
      {{ roleText }}<ng-container *ngIf="roleText && presenceText"> · </ng-container>
      <span *ngIf="presenceText" [class.chat-details__online]="presence === 'online'">{{ presenceText }}</span>
    </p>
    <div class="chat-details__quick">
      <a *ngIf="propertyRoute" class="chat-details__chip" [routerLink]="propertyRoute" [queryParams]="propertyQueryParams">
        <chat-icon name="home" [size]="14"></chat-icon>{{ strings.openPropertyShort }}
      </a>
      <a *ngIf="conv.propertyLink" class="chat-details__chip" [href]="conv.propertyLink" target="_blank" rel="noopener">
        <chat-icon name="external" [size]="14"></chat-icon>{{ strings.openSiteShort }}
      </a>
      <button *ngIf="canInvite" type="button" class="chat-details__chip" (click)="invite.emit()">
        <chat-icon name="userplus" [size]="14"></chat-icon>{{ strings.inviteShort }}
      </button>
      <button *ngIf="canTransfer" type="button" class="chat-details__chip" (click)="transfer.emit()">
        <chat-icon name="transfer" [size]="14"></chat-icon>{{ strings.transferShort }}
      </button>
    </div>
  </div>

  <section *ngIf="rows.length > 0" class="chat-details__section" [attr.aria-label]="strings.infoTitle">
    <h3 class="chat-details__h">{{ strings.infoTitle }}</h3>
    <dl class="chat-details__rows">
      <div *ngFor="let r of rows" class="chat-details__row">
        <dt>{{ r.label }}</dt>
        <dd [class.chat-details__online]="r.tone === 'online'" [class.chat-details__away]="r.tone === 'away'">{{ r.value }}</dd>
      </div>
    </dl>
  </section>

  <!-- v3: o cliente e a lead da conversa (chat_users.lead_id) -->
  <section *ngIf="clientRows.length > 0 || temperature" class="chat-details__section" [attr.aria-label]="strings.clientTitle">
    <h3 class="chat-details__h">{{ strings.clientTitle }}
      <span *ngIf="temperature" class="chat-details__temp" [ngClass]="'chat-details__temp--' + temperature">{{ temperatureText }}</span>
    </h3>
    <dl class="chat-details__rows">
      <div *ngFor="let r of clientRows" class="chat-details__row">
        <dt>{{ r.label }}</dt>
        <dd><a *ngIf="r.href; else plainValue" [href]="r.href">{{ r.value }}</a><ng-template #plainValue>{{ r.value }}</ng-template></dd>
      </div>
    </dl>
  </section>

  <!-- v3: etapa do negócio -->
  <section *ngIf="conv.lead" class="chat-details__section" [attr.aria-label]="strings.dealTitle">
    <h3 class="chat-details__h">{{ strings.dealTitle }}</h3>
    <ng-container *ngIf="conv.deal as deal; else noDeal">
      <a class="chat-details__deal" [routerLink]="['/deals', 'sale', deal.id]">
        <span class="chat-details__deal-dot" [style.background]="deal.color || null"></span>
        <span class="chat-details__deal-text">
          <span class="chat-details__deal-stage">{{ dealStageText }}</span>
          <span class="chat-details__deal-sub">{{ strings.openDeal }}</span>
        </span>
        <chat-icon name="next" [size]="14"></chat-icon>
      </a>
    </ng-container>
    <ng-template #noDeal><p class="chat-details__empty">{{ strings.noDealYet }}</p></ng-template>
    <!-- 7.3: avançar etapa (o servidor exige MOVE_DEALS) -->
    <button *ngIf="conv.deal && dealStages && dealStages.next && !conv.deal.isWon && !conv.deal.isLost" type="button"
      class="chat-details__invite" [disabled]="stageBusy" (click)="advanceStage.emit(dealStages.next!)">
      <chat-icon name="next" [size]="14"></chat-icon>{{ advanceLabel }}
    </button>
  </section>

  <!-- 7.3: próxima ação (lembrete ou visita) -->
  <section *ngIf="canRemind" class="chat-details__section" [attr.aria-label]="strings.nextActionLabel">
    <h3 class="chat-details__h">{{ strings.nextActionLabel }}</h3>
    <p class="chat-details__next" [class.chat-details__empty]="!nextAction">{{ nextAction ? nextActionText : strings.noNextAction }}</p>
    <button type="button" class="chat-details__invite" (click)="addReminder.emit()">
      <chat-icon name="clock" [size]="14"></chat-icon>{{ strings.addReminder }}
    </button>
  </section>

  <section *ngIf="showColleagues" class="chat-details__section" [attr.aria-label]="strings.colleaguesTitle">
    <h3 class="chat-details__h">{{ strings.colleaguesTitle }}</h3>
    <p *ngIf="colleagues.length === 0" class="chat-details__empty">{{ strings.noColleagues }}</p>
    <div *ngFor="let c of colleagues; trackBy: trackByColleague" class="chat-details__person">
      <chat-avatar [src]="c.photo" [name]="c.name" [size]="32"></chat-avatar>
      <div class="chat-details__person-text">
        <div class="chat-details__person-name">{{ c.name }}</div>
        <div class="chat-details__person-role" [class.chat-details__person-role--lead]="c.responsible">{{ c.role }}</div>
      </div>
      <button *ngIf="canRemoveParticipants && !c.responsible && !c.me" type="button" class="chat-details__person-x"
        [attr.aria-label]="strings.removeParticipant" [ngbTooltip]="strings.removeParticipant" container="body" (click)="removeParticipant.emit(c.id)">
        <chat-icon name="close" [size]="13"></chat-icon>
      </button>
    </div>
    <ng-container *ngIf="pendingInvites.length > 0">
      <div class="chat-details__subh">{{ strings.invitesPending }}</div>
      <div *ngFor="let p of pendingInvites; trackBy: trackByInvite" class="chat-details__person chat-details__person--pending">
        <chat-avatar [src]="invitePhoto(p.profile)" [name]="p.name" [size]="32"></chat-avatar>
        <div class="chat-details__person-text">
          <div class="chat-details__person-name">{{ p.name }}</div>
          <div class="chat-details__person-role">{{ waitingText(p) }}</div>
        </div>
        <button *ngIf="canInvite" type="button" class="chat-details__person-x" [attr.aria-label]="strings.inviteCancel"
          [ngbTooltip]="strings.inviteCancel" container="body" (click)="cancelInvite.emit(p.userAppId)">
          <chat-icon name="close" [size]="13"></chat-icon>
        </button>
      </div>
    </ng-container>
    <button *ngIf="canInvite" type="button" class="chat-details__invite" (click)="invite.emit()">
      <chat-icon name="userplus" [size]="14"></chat-icon>{{ strings.inviteColleague }}
    </button>
    <button *ngIf="canLeave" type="button" class="chat-details__invite chat-details__invite--muted" (click)="leave.emit()">
      <chat-icon name="close" [size]="14"></chat-icon>{{ strings.leaveChat }}
    </button>
  </section>

  <section *ngIf="conv.propertyReference || conv.propertyTitle" class="chat-details__section" [attr.aria-label]="strings.conversationPropertyTitle">
    <h3 class="chat-details__h">{{ strings.conversationPropertyTitle }}</h3>
    <a *ngIf="propertyRoute; else propertyStatic" class="chat-details__prop" [routerLink]="propertyRoute" [queryParams]="propertyQueryParams">
      <span class="chat-details__prop-icon"><chat-icon name="home" [size]="18"></chat-icon></span>
      <span class="chat-details__prop-text">
        <span *ngIf="conv.propertyReference" class="chat-details__prop-ref">{{ conv.propertyReference }}</span>
        <span *ngIf="conv.propertyTitle" class="chat-details__prop-title">{{ conv.propertyTitle }}</span>
      </span>
      <chat-icon name="next" [size]="14"></chat-icon>
    </a>
    <ng-template #propertyStatic>
      <div class="chat-details__prop chat-details__prop--static">
        <span class="chat-details__prop-icon"><chat-icon name="home" [size]="18"></chat-icon></span>
        <span class="chat-details__prop-text">
          <span *ngIf="conv.propertyReference" class="chat-details__prop-ref">{{ conv.propertyReference }}</span>
          <span *ngIf="conv.propertyTitle" class="chat-details__prop-title">{{ conv.propertyTitle }}</span>
        </span>
      </div>
    </ng-template>
  </section>

  <section *ngIf="sentProperties.length > 0" class="chat-details__section" [attr.aria-label]="strings.sentPropertiesTitle">
    <h3 class="chat-details__h">{{ strings.sentPropertiesTitle }}</h3>
    <div class="chat-details__cards">
      <ng-container *ngFor="let p of sentProperties; trackBy: trackByProperty">
        <a *ngIf="p.route; else cardStatic" class="chat-details__card" [routerLink]="p.route" [queryParams]="p.queryParams">
          <ng-container *ngTemplateOutlet="cardBody; context: { p: p }"></ng-container>
        </a>
        <ng-template #cardStatic>
          <a *ngIf="p.link; else cardPlain" class="chat-details__card" [href]="p.link" target="_blank" rel="noopener">
            <ng-container *ngTemplateOutlet="cardBody; context: { p: p }"></ng-container>
          </a>
          <ng-template #cardPlain>
            <div class="chat-details__card"><ng-container *ngTemplateOutlet="cardBody; context: { p: p }"></ng-container></div>
          </ng-template>
        </ng-template>
      </ng-container>
    </div>
  </section>
</div>

<ng-template #cardBody let-p="p">
  <span class="chat-details__card-photo">
    <img *ngIf="p.image" [src]="p.image" alt="" loading="lazy">
    <chat-icon *ngIf="!p.image" name="home" [size]="20"></chat-icon>
  </span>
  <span class="chat-details__card-text">
    <span class="chat-details__card-title">{{ p.title || p.reference }}</span>
    <span *ngIf="priceOf(p)" class="chat-details__card-price">{{ priceOf(p) }}</span>
  </span>
</ng-template>
